<template>
  <div class="c-virtual-list__col position" :class="positionClass">
    <template v-if="item.isLoading"></template>
    <template v-else-if="isNoData">
      -
    </template>
    <template v-else-if="isGetting">
      <Icon2 variant="attention" :size="14" />
    </template>
    <template v-else>
      {{
        item.position
          | roundDownFloatingPointNumber(1)
          | roundNumberText(100)
          | nullToHyphen
      }}
    </template>
    <img
      v-if="hasDoneTask"
      class="c-virtual-list__task-flag"
      :src="taskFlagImgPath"
    />
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';

export default {
  props: {
    item: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          position: null,
          isLoading: true,
          type: null,
          isProposal: null
        };
      }
    }
  },
  data() {
    return {
      taskFlagImgPath: null
    };
  },
  components: {
    Icon2
  },
  computed: {
    positionClass() {
      const position = this.item.position;
      if (this.isNoData) {
        return 'is-nodata';
      } else if (this.isGetting) {
        return 'is-getting';
      } else if (position < 2) {
        return 'is-rank1';
      } else if (position >= 2 && position < 6) {
        return 'is-rank2';
      } else if (position >= 6 && position < 11) {
        return 'is-rank3';
      } else if (position >= 11 && position < 100) {
        return 'is-rank4';
      } else if (position >= 100) {
        return 'is-rank5';
      }
      return '';
    },
    isGetting() {
      return this.item.position === null;
    },
    isNoData() {
      return this.item.position === 0;
    },
    hasDoneTask() {
      return this.item.type != null;
    }
  },
  methods: {
    loading() {
      if (!this.hasDoneTask) {
        return;
      }

      if (this.item.isProposal) {
        this.taskFlagImgPath = require('@/assets/img/flag-task-proposal.svg');
      } else {
        this.taskFlagImgPath = require('@/assets/img/flag-task-' +
          this.item.type +
          '.svg');
      }
    }
  },
  mounted() {
    this.loading();
  },
  updated() {
    this.loading();
  }
};
</script>
